import WeldNdtTestForm from './WeldNdtTestForm'
import { RT_METHOD_CONFIG } from '@/types/weldNdtTypes'

const RTTestForm = () => <WeldNdtTestForm config={RT_METHOD_CONFIG} />

export default RTTestForm
